import React from 'react';

import Helmet from 'wanderu-component-helmet';
import { localize } from 'wanderu-i18n';

import auConfig from '../../config/aboutus.locale';

function AboutUsMeta(props) {
    const {
        t,
        ...otherProps
    } = props;

    const title = t('about-us-meta-title');
    const description = t('about-us-meta-description');

    return (
        <Helmet
            {...otherProps}
            description={description}
            supportedLocales={auConfig.supportedLocales}
            title={title}
        />
    );
}

export { AboutUsMeta };
export default localize(AboutUsMeta, ['t'], 'baseApp');
